import _ from "lodash"
export const getProgramName = name => _.lowerCase(_.join(_.split(name," "),"-"));
